import { render, staticRenderFns } from "./shippingSelect.vue?vue&type=template&id=49f3e9b8"
import script from "./shippingSelect.vue?vue&type=script&lang=js"
export * from "./shippingSelect.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./shippingSelect.vue?vue&type=style&index=0&id=49f3e9b8&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "32531b12"
  
)

export default component.exports